import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * SupportDriftBlock — Coffin Nail #46. Public Warden-on-Support drift stats.
 * Every Support turn graded post-hoc; flagged answers file a Ledger row.
 */
export default function SupportDriftBlock() {
  const [d, setD] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/sage/support/drift`);
        if (r.ok && !cancelled) setD(await r.json());
      } catch {}
    })();
    return () => { cancelled = true; };
  }, []);
  if (!d) return null;
  const rate = d.clean_rate_pct ?? 100;
  return (
    <div className="border border-sage-border p-6" data-testid="support-drift-block">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-3">
        <div className="text-xs uppercase tracking-[0.15em] text-sage-muted">
          Sage Support · Warden verdicts
        </div>
        <div className={`text-[10px] uppercase tracking-[0.15em] tabular-nums ${rate === 100 ? "text-sage-accent" : (rate >= 90 ? "text-sage-warn" : "text-sage-err")}`}>
          {rate}% clean
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="border border-sage-border p-3">
          <div className="text-[10px] uppercase text-sage-faint">Total turns</div>
          <div className="text-2xl font-bold tabular-nums text-sage-accent" data-testid="support-drift-total">{d.total_support_turns ?? 0}</div>
        </div>
        <div className="border border-sage-border p-3">
          <div className="text-[10px] uppercase text-sage-faint">Flagged</div>
          <div className={`text-2xl font-bold tabular-nums ${(d.flagged_turns ?? 0) > 0 ? "text-sage-warn" : "text-sage-accent"}`} data-testid="support-drift-flagged">
            {d.flagged_turns ?? 0}
          </div>
        </div>
        <div className="border border-sage-border p-3">
          <div className="text-[10px] uppercase text-sage-faint">Hallucinations</div>
          <div className="text-2xl font-bold tabular-nums text-sage-warn">{d.hallucination_flags ?? 0}</div>
        </div>
        <div className="border border-sage-border p-3">
          <div className="text-[10px] uppercase text-sage-faint">Sycophancy</div>
          <div className="text-2xl font-bold tabular-nums text-sage-warn">{d.sycophancy_flags ?? 0}</div>
        </div>
      </div>
      <div className="mt-3 text-[10px] uppercase tracking-[0.15em] text-sage-faint">
        {d.law}
      </div>
      <GraderGraderStrip />
    </div>
  );
}

function GraderGraderStrip() {
  const [d, setD] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/sage/warden/false-positive-rate`);
        if (r.ok) setD(await r.json());
      } catch {}
    })();
  }, []);
  if (!d || d.total_regraded === 0) {
    return (
      <div className="mt-4 pt-4 border-t border-sage-border text-[10px] uppercase tracking-[0.15em] text-sage-faint" data-testid="grader-grader-empty">
        The Grader's Grader has not run yet. When it does, its false-positive rate lands here.
      </div>
    );
  }
  return (
    <div className="mt-4 pt-4 border-t border-sage-border" data-testid="grader-grader-strip">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
        <div className="text-[10px] uppercase tracking-[0.2em] text-sage-faint">
          The Grader's Grader · Warden re-graded with canon
        </div>
        <div className={`text-[10px] uppercase tracking-[0.15em] tabular-nums ${d.false_positive_rate_pct > 20 ? "text-sage-warn" : "text-sage-accent"}`} data-testid="grader-grader-rate">
          {d.false_positive_rate_pct}% false-positive rate
        </div>
      </div>
      <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint tabular-nums">
        {d.total_regraded} re-grades · {d.total_false_positives} false positives · last run {d.last_run_at ? new Date(d.last_run_at).toLocaleString() : "—"}
      </div>
      <p className="mt-2 text-xs text-sage-muted leading-relaxed sage-prose">
        {d.note}
      </p>
    </div>
  );
}
